import { UserService } from "@movicoders/domain";
import { TYPES } from "@movicoders/domain";
import { useResolve } from "@movicoders/di";


export const usePermission = (permissions: string[] = []) => {
  const { user } = useResolve<UserService>(TYPES.UserService);

  return user && user.hasPermission(permissions);
};
